module.exports = __webpack_public_path__ + "img/ico-twitter-circle.9cb3a109.svg";